export default __webpack_public_path__ + "static/product2-709d9613764cefb653c367f1f8f28361.png";